{
	"version": "25.01",
	"title": "SIM, TIM & OIM",
	"type": 1,
	"graph": [
		["http://www.snik.eu/ontology/bb/ProjectInitiation", { "x": 1040, "y": 700 }],
		["http://www.snik.eu/ontology/bb/Management", { "x": 950, "y": 50 }],
		["http://www.snik.eu/ontology/bb/InformationManagement", { "x": 1400, "y": 50 }],
		["http://www.snik.eu/ontology/bb/HealthInformationSystem", { "x": 630, "y": 940 }],
		["http://www.snik.eu/ontology/bb/TacticalHISPlanning", { "x": 1250, "y": 550 }],
		["http://www.snik.eu/ontology/bb/StrategicHISDirecting", { "x": 830, "y": 550 }],
		["http://www.snik.eu/ontology/bb/InformationSystem", { "x": 730, "y": 900 }],
		["http://www.snik.eu/ontology/bb/TacticalHISDirecting", { "x": 1400, "y": 550 }],
		["http://www.snik.eu/ontology/bb/ProjectPlan", { "x": 1325, "y": 700 }],
		["http://www.snik.eu/ontology/bb/StrategicInformationManagementPlan", { "x": 730, "y": 490 }],
		["http://www.snik.eu/ontology/bb/OperationalHISMonitoring", { "x": 2120, "y": 550 }],
		["http://www.snik.eu/ontology/bb/ArchitectureOfAnInformationSystem", { "x": 730, "y": 700 }],
		["http://www.snik.eu/ontology/bb/HospitalManagement", { "x": 500, "y": 50 }],
		["http://www.snik.eu/ontology/bb/ChiefInformationOfficer", { "x": 1400, "y": -80 }],
		["http://www.snik.eu/ontology/bb/TacticalInformationManagement", { "x": 1400, "y": 250 }],
		["http://www.snik.eu/ontology/bb/TacticalHISMonitoring", { "x": 1550, "y": 550 }],
		["http://www.snik.eu/ontology/bb/TopManagement", { "x": 500, "y": -80 }],
		["http://www.snik.eu/ontology/bb/StrategicInformationManagement", { "x": 830, "y": 250 }],
		["http://www.snik.eu/ontology/bb/OperationalHISPlanning", { "x": 1820, "y": 550 }],
		["http://www.snik.eu/ontology/bb/StrategicHISPlanning", { "x": 630, "y": 550 }],
		["http://www.snik.eu/ontology/bb/ComputerBasedApplicationComponent", { "x": 1685, "y": 400 }],
		["http://www.snik.eu/ontology/bb/HisArchitecture", { "x": 730, "y": 610 }],
		["http://www.snik.eu/ontology/bb/OperationalHISDirecting", { "x": 1970, "y": 550 }],
		["http://www.snik.eu/ontology/bb/OperationalInformationManagement", { "x": 1970, "y": 250 }],
		["http://www.snik.eu/ontology/bb/ApplicationComponent", { "x": 1685, "y": 320 }],
		["http://www.snik.eu/ontology/bb/StrategicHISMonitoring", { "x": 980, "y": 550 }],
		["http://www.snik.eu/ontology/bb/HospitalInformationSystem", { "x": 630, "y": 860 }]
	]
}
